import Title from "../components/ui/Title";
import Button from "../components/ui/Button";
import { useState } from 'react';
import GalleryData from '../data/GalleryData';
import Modal from '../components/ui/Modal';
import '../styles/pages/gallery.scss'

const FanArt = () => {

    const [current, changeCurrent] = useState(1)
    const setCurrent = (index) =>{
        changeCurrent(index)
    }

  const shuffle = (array) => {
        let currentIndex = array.length,  randomIndex;
    
        // While there remain elements to shuffle.
        while (currentIndex != 0) {
    
        // Pick a remaining element.
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;
    
        // And swap it with the current element.
        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        }
    
        return array;
    }   

    const shuffled = GalleryData;

    return (
        <div className="page-container">
            <Title text="FAN ART GALLERY"/>
            <div className="to-top" onClick={()=>{
                window.scrollTo(0,0)
            }}>
                <h1>
                    To Top
                </h1>
            </div>
            <div className="main-container">
                <div className="outline">
                    <h1 className="gallery-title">
                        Crossbell Pet Department
                    </h1>
                    <p className="gallery-header">
                        C.P.D, reporting for duty! <br/>
                        Check out this gallery showcasing our pet-tacular crew!
                    </p>
                  <section className="gallery-container">
                      {
                          shuffled.map((pet, index)=>{
                              return (
                                  <>
                                      <Modal component={<GalleryFull index={index} current={current} changeArt={setCurrent} array={shuffled}/>}>
                                          <div className="character-image" style={{
                                              backgroundImage: `url(../img/gallery/icons/${pet}.jpg)`
                                          }} onClick={()=>setCurrent(index)}>
                                              <h1>{removeNumber(pet)}</h1>
                                          </div>
                                      </Modal>
                                  </>
                              )
                          })
                      }
                  </section>
                </div>
            </div>
        </div>
    )
}

const removeNumber = (name) => {
    if(name.substring(name.length-1,name.length) === "1") {
        return name.substring(0, name.length-1)
    }
    if(name.substring(name.length-1,name.length) === "2") {
        return name.substring(0, name.length-1)
    }
    if(name.substring(name.length-1,name.length) === "3") {
        return name.substring(0, name.length-1)
    }
    if(name.substring(name.length-1,name.length) === "4") {
        return name.substring(0, name.length-1)
    }
    return (
        name
    )
}

const GalleryFull = ({index, changeArt, current, array}) => (
    <div className="gallery-wrapper">
        <img src={`${process.env.PUBLIC_URL}/img/gallery/medium/${array[current]}.jpg`} alt="" className="gallery-image"/>
        <h1 className="artist-handle">
            {
                removeNumber(array[current])
            }
        </h1>
        <div className="next-container">
            {
                (current !== 0) && <Button
                    text="Previous"
                    type="gradient"
                    color="blue"
                    onClick={()=>{
                        if(index >= 0) {
                            changeArt(current-1)
                        }
                    }}
                />
            }
            {
                (current !== array.length-1) && <Button
                    text="Next"
                    type="gradient"
                    color="blue"
                    onClick={()=>{
                        if(current !==  array.length-1) {
                            changeArt(current+1)
                            console.log(current+1)
                        }
                    }}
                />
            }
        </div>
    </div>
)

export default FanArt;